<div class="flash-form-container">
  <div class="flash-form-container-title text-center">
    Selecionar forma de pago:
  </div>

  <app-options-for-payment (action)="selectPaymentOption($event)"></app-options-for-payment>

  <div class="cards-container" *ngIf="flashPaymentService.controller.isCard && flashPaymentService.controller.isCardVisible">
    <app-credit-card [cantShowArrows]="cantShowArrows"  [openForm]="openForm" (action)="changeIcon($event)"></app-credit-card>
  </div>

  <div class="ACH-container" *ngIf="flashPaymentService.controller.isACH && flashPaymentService.controller.isACHVisible">
    <app-ach></app-ach>
  </div>

  <div class="place-to-pay-container" *ngIf="flashPaymentService.controller.isPlaceToPay && flashPaymentService.controller.isPlaceToPayVisible">
    <app-wallet [cantShowArrows]="cantShowArrows"></app-wallet>
  </div>
</div>
